import { render, staticRenderFns } from "./StepDots.vue?vue&type=template&id=353db2f9&scoped=true&"
import script from "./StepDots.vue?vue&type=script&lang=js&"
export * from "./StepDots.vue?vue&type=script&lang=js&"
import style0 from "./StepDots.vue?vue&type=style&index=0&id=353db2f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353db2f9",
  null
  
)

export default component.exports